import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let PopImapOption: LazyOption = createLazyOption(
    {
        key: 'popImap',
        titleStringKey: 'optionTitle_popAndImap',
        searchTermsStringKey: 'optionTitle_popAndImap',
        isHidden: () => !isFeatureEnabled('fwk-option-popImap'),
        allowedOptionKeys: ['PopAndImap'],
    },
    lazyFullModule,
    m => m.default
);
export default PopImapOption;
